'use client';
import { Button } from '@ui/uikit/components/common/Button';

import { getChainNameById, useSwitchChain } from '../chain';

type SwitchChainButtonProps = {
  destChainId: number;
};

export const SwitchChainButton = ({ destChainId }: SwitchChainButtonProps) => {
  const { switchChain, isSwitching } = useSwitchChain();

  const chainName = getChainNameById(destChainId);

  const onClickSwitch = () => {
    void switchChain({ destChainId });
  };

  return (
    <Button disabled={isSwitching} onClick={onClickSwitch} type="button" size="large" width="100%">
      {`Switch to ${chainName} Network`}
    </Button>
  );
};
